(function(){'use strict';function initParticles(){var hero=document.querySelector('[id$="__hero"]')||document.querySelector('.banner');if(!hero)return;var canvas=document.createElement('canvas');canvas.id='cc-particles';canvas.style.cssText=['position:absolute','top:0','left:0','width:100%','height:100%','pointer-events:none','z-index:4','opacity:0','transition:opacity 1.4s ease'].join(';');if(getComputedStyle(hero).position==='static')hero.style.position='relative';hero.appendChild(canvas);var ctx=canvas.getContext('2d');var W,H,particles=[],raf;function resize(){W=canvas.width=hero.offsetWidth;H=canvas.height=hero.offsetHeight;}function Particle(){this.reset(true);}Particle.prototype.reset=function(init){this.x=Math.random()*W;this.y=init?Math.random()*H:H+5;this.r=Math.random()*1.5+0.25;this.vy=-(Math.random()*0.30+0.08);this.vx=(Math.random()-0.5)*0.15;this.a=Math.random()*0.5+0.1;this.da=(Math.random()-0.5)*0.003;};Particle.prototype.update=function(){this.x+=this.vx;this.y+=this.vy;this.a+=this.da;if(this.a<0.05)this.da=Math.abs(this.da);if(this.a>0.65)this.da=-Math.abs(this.da);if(this.y<-4)this.reset(false);};function build(){var n=Math.min(Math.floor((W*H)/6000),220);particles=[];for(var i=0;i<n;i++)particles.push(new Particle());}function draw(){ctx.clearRect(0,0,W,H);for(var i=0;i<particles.length;i++){var p=particles[i];p.update();ctx.beginPath();ctx.arc(p.x,p.y,p.r,0,6.283185);ctx.fillStyle='rgba(255,238,195,'+p.a.toFixed(3)+')';ctx.fill();}raf=requestAnimationFrame(draw);}function start(){resize();build();draw();setTimeout(function(){canvas.style.opacity='1';},300);}window.addEventListener('resize',function(){resize();build();});document.addEventListener('visibilitychange',function(){if(document.hidden)cancelAnimationFrame(raf);else draw();});start();}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initParticles);}else{initParticles();}})();

/* Product card hover: cycle through a product's photos (hover-capable devices only) */
(function(){'use strict';
  if(!window.matchMedia||!matchMedia('(hover: hover)').matches||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var cache={},timers=new WeakMap();
  function getImgs(handle){
    if(cache[handle])return cache[handle];
    cache[handle]=fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(p){
      return (p.images||[]).slice(0,8).map(function(u){return u.replace(/^\/\//,'https://')+(u.indexOf('?')>-1?'&':'?')+'width=720';});
    }).catch(function(){return [];});
    return cache[handle];
  }
  function start(card){
    var link=card.querySelector('a.full-unstyled-link[href*="/products/"]');
    if(!link)return;
    var m=link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    var media=card.querySelector('.card__media .media');
    if(!m||!media)return;
    card.__ccOn=true;
    getImgs(m[1]).then(function(urls){
      if(!card.__ccOn||urls.length<2)return;
      var ov=media.querySelector('.cc-cycle');
      if(!ov){
        ov=document.createElement('img');
        ov.className='cc-cycle';ov.alt='';ov.setAttribute('aria-hidden','true');
        ov.style.cssText='position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .35s ease;z-index:2;pointer-events:none;';
        media.appendChild(ov);
      }
      var i=1;
      function show(){
        var u=urls[i%urls.length];
        var im=new Image();
        im.onload=function(){if(card.__ccOn){ov.src=u;ov.style.opacity='1';}};
        im.src=u;
        i++;if(i%urls.length===0)i++;
      }
      show();
      timers.set(card,setInterval(show,1200));
    });
  }
  function stop(card){
    card.__ccOn=false;
    var t=timers.get(card);
    if(t){clearInterval(t);timers.delete(card);}
    var ov=card.querySelector('.cc-cycle');
    if(ov)ov.style.opacity='0';
  }
  document.addEventListener('mouseover',function(e){
    var c=e.target.closest&&e.target.closest('.product-card-wrapper');
    if(c&&!c.__ccOn)start(c);
  });
  document.addEventListener('mouseout',function(e){
    var c=e.target.closest&&e.target.closest('.product-card-wrapper');
    if(c&&c.__ccOn&&!c.contains(e.relatedTarget))stop(c);
  });
})();
